export const GRANTED_ROLES = ['viewer', 'editor'] as const;
export type GrantedRole = (typeof GRANTED_ROLES)[number];
export type UserRole = GrantedRole | 'superadmin';

export const ROLE_LABELS: Record<UserRole, string> = {
  viewer: 'Наблюдатель',
  editor: 'Редактор',
  superadmin: 'Супер-администратор',
};
